import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMicOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], f = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.646.646a.5.5 0 0 1 .708 0l7.5 7.5 2.5 2.5a.5.5 0 0 1-.708.708L8.481 9.188a4 4 0 0 1-1.981.832V11H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5v-.98A4.001 4.001 0 0 1 2 5.996V5a.5.5 0 0 1 1 0v1.007a3 3 0 0 0 4.768 2.468l-.753-.753A2 2 0 0 1 4 6V4.707L.646 1.354a.5.5 0 0 1 0-.708ZM5 5.707V6a1 1 0 0 0 1.258.965L5 5.707Zm.153-5.01A2 2 0 0 1 8 2.497V4.67a.5.5 0 0 1-1 0V2.502a1 1 0 0 0-1.893-.442.5.5 0 0 1-.894-.45 2 2 0 0 1 .94-.913ZM9.5 4.5a.5.5 0 0 1 .5.5v1.001c0 .235-.022.47-.063.702a.5.5 0 1 1-.984-.176A3.06 3.06 0 0 0 9 6V5a.5.5 0 0 1 .5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  f
], m = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function v(e, I, d, V, b, t) {
  return n(), l("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--mic-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Mic Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, h, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, m)
    ])
  ], 10, _);
}
const A = /* @__PURE__ */ s(c, [["render", v]]);
export {
  A as default
};
//# sourceMappingURL=mic-off.js.map
